import React from 'react';

import StopExtras from 'modules/journey/Stop/StopExtras';

import StopLoad from '../StopLoad';
import { IS_TENANT } from 'tenant/config';

const loadParse = {
  PICKUP: 'load_pickup',
  DROPOFF: 'load_dropoff',
};

const LoadsRow = ({ stop, className, item }) => {
  const loads = (stop || {})[loadParse[stop?.stop_type]];

  const tenantLoadWeight =
    loads?.length > 1
      ? loads
          .map((l, i) => (l.container_iso_code ? 0 : l.total_weight / 1))
          .reduce((n, p) => p + n, 0)
      : 0;

  return (
    <div className={className}>
      <div>
        {(loads || []).map((load, key) => (
          <>
            {IS_TENANT ? (
              <>
                {load?.container_iso_code && (
                  <StopLoad
                    key={key}
                    {...load}
                    total_weight={tenantLoadWeight}
                    stop={stop}
                    style={{ width: '100%' }}
                  />
                )}
              </>
            ) : (
              <StopLoad key={key} stop={stop} {...load} style={{ width: '100%' }} />
            )}
          </>
        ))}
      </div>
      <div>
        <StopExtras {...stop} iconSize="18" />
      </div>
    </div>
  );
};

export default LoadsRow;
